// @storybook-skip: decorative artwork rendered inside CmeCertificateCard
import Svg, { Path } from "react-native-svg";
import { useAppTheme } from "../../useAppTheme";

type Props = {
	size?: number;
};

export const CmeCertificateIllustration = ({ size = 78 }: Props) => {
	const theme = useAppTheme();

	return (
		<Svg width={size} height={size} viewBox="0 0 78 78" fill="none">
			<Path
				d="M6.49971 14.625H71.4997V63.375H6.49971V14.625Z"
				fill={theme.colors.secondaryContainer}
			/>
			<Path
				d="M48.7505 55.2499H53.3005L45.1755 47.1249L40.6255 51.6749L48.7505 59.7999V55.2499ZM29.2505 55.2499H24.7005L32.8255 47.1249L37.3755 51.6749L29.2505 59.7999V55.2499Z"
				fill={theme.colors.primary}
			/>
			<Path
				d="M17.8753 24.3749H60.1253V30.8749H17.8753V24.3749ZM39.0003 37.3749C34.4503 37.3749 30.8753 40.9499 30.8753 45.4999C30.8753 50.0499 34.4503 53.6249 39.0003 53.6249C43.5503 53.6249 47.1253 50.0499 47.1253 45.4999C47.1253 40.9499 43.5503 37.3749 39.0003 37.3749ZM39.0003 50.3749C36.2378 50.3749 34.1253 48.2624 34.1253 45.4999C34.1253 42.7374 36.2378 40.6249 39.0003 40.6249C41.7628 40.6249 43.8753 42.7374 43.8753 45.4999C43.8753 48.2624 41.7628 50.3749 39.0003 50.3749Z"
				fill={theme.colors.onSecondaryContainer}
			/>
			<Path
				d="M4.875 12.9999V64.9999H73.125V12.9999H4.875ZM69.875 56.8749C67.1125 56.8749 65 58.9874 65 61.7499H13C13 58.9874 10.8875 56.8749 8.125 56.8749V21.1249C10.8875 21.1249 13 19.0124 13 16.2499H65C65 19.0124 67.1125 21.1249 69.875 21.1249V56.8749Z"
				fill={theme.colors.onSecondaryContainer}
			/>
		</Svg>
	);
};
